import PlansList from './PlansListContainer';

export default PlansList;
